import React, { useEffect, useState, useRef } from "react"
import avatar from "assets/images/user/avatarUser.svg"
import styles from "./adminUserList.module.scss"

function ProfileDisplayer({ image, isPopupAvatar }) {
  const [isLoading, setIsLoading] = useState(true)
  const imgRef = useRef(null)

  useEffect(() => {
    setIsLoading(true)

    // Small delay to check if image is already cached/loaded
    const timeoutId = setTimeout(() => {
      if (imgRef.current) {
        if (imgRef.current.complete && imgRef.current.naturalHeight !== 0) {
          setIsLoading(false)
        }
      }
    }, 0)

    return () => clearTimeout(timeoutId)
  }, [image])

  const handleImageLoad = (e) => {
    if (e.target.naturalHeight !== 0) {
      setIsLoading(false)
    }
  }

  const handleImageError = () => {
    setIsLoading(false)
  }

  return (
    <div className={isPopupAvatar ? styles.popUpAvatar : styles.tableAvatar}>
      {isLoading && <img src={avatar} alt="Avatar" className={styles.imgActual} />}

      <img
        ref={imgRef}
        src={image}
        onLoad={handleImageLoad}
        onError={handleImageError}
        alt="Avatar"
        className={styles.imgActual}
        style={{ display: isLoading ? "none" : "block" }}
      />
    </div>
  )
}

export default ProfileDisplayer
